var _path, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 51,
    viewBox: "0 0 58 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6571 10.5832C40.9132 9.70945 40.1692 9.31054 39.0346 9.31054H13.9163C13.3211 9.31054 12.8376 8.85465 12.7818 8.2449L12.4284 3.9899C12.3726 3.34405 11.9076 2.81408 11.2752 2.6982L6.83929 2.01627C6.07672 1.90039 5.35135 2.41517 5.22115 3.19209C5.09096 3.95191 5.61174 4.69273 6.35571 4.8257V4.8257C8.01041 5.11669 9.26068 6.4871 9.39904 8.16149L10.8753 26.0266C11.0799 28.534 13.1258 30.4697 15.5995 30.4697H35.8914C38.2535 30.4697 40.2622 28.705 40.597 26.3096L42.3639 13.8486C42.5313 12.7107 42.4011 11.457 41.6571 10.5832",
    fill: "url(#paint0_linear_2927_19602)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2927_19602)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.0449,
    y: 14.3926,
    width: 22.3059,
    height: 13.3836,
    rx: 5,
    fill: "#2AA42B",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2927_19602)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_2927_19602",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 8.51953,
    width: 43,
    height: 43,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 15,
    y: 8.51953,
    width: 43,
    height: 43
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2096 17.469C18.9759 17.469 18.1669 17.9028 17.3579 18.8529C16.5489 19.8031 16.4073 21.1664 16.5893 22.4036L18.5107 35.9538C18.8747 38.5584 21.059 40.4774 23.6276 40.4774H45.6928C48.3827 40.4774 50.6075 38.3725 50.8299 35.646L52.6906 13.1292L55.7446 12.5922C56.5536 12.4476 57.1198 11.642 56.9783 10.8158C56.8367 9.97099 56.0479 9.41122 55.2187 9.53722L50.3951 10.2788C49.7075 10.4048 49.2018 10.9811 49.1412 11.6833L48.7569 16.3102C48.6962 16.9733 48.1704 17.469 47.5232 17.469H20.2096ZM46.0171 43.7423C47.716 43.7423 49.0913 45.1469 49.0913 46.882C49.0913 48.5964 47.716 50.001 46.0171 50.001C44.3384 50.001 42.9632 48.5964 42.9632 46.882C42.9632 45.1469 44.3384 43.7423 46.0171 43.7423ZM23.2644 43.7423C24.9633 43.7423 26.3385 45.1469 26.3385 46.882C26.3385 48.5964 24.9633 50.001 23.2644 50.001C21.5857 50.001 20.2104 48.5964 20.2104 46.882C20.2104 45.1469 21.5857 43.7423 23.2644 43.7423Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2096 17.469C18.9759 17.469 18.1669 17.9028 17.3579 18.8529C16.5489 19.8031 16.4073 21.1664 16.5893 22.4036L18.5107 35.9538C18.8747 38.5584 21.059 40.4774 23.6276 40.4774H45.6928C48.3827 40.4774 50.6075 38.3725 50.8299 35.646L52.6906 13.1292L55.7446 12.5922C56.5536 12.4476 57.1198 11.642 56.9783 10.8158C56.8367 9.97099 56.0479 9.41122 55.2187 9.53722L50.3951 10.2788C49.7075 10.4048 49.2018 10.9811 49.1412 11.6833L48.7569 16.3102C48.6962 16.9733 48.1704 17.469 47.5232 17.469H20.2096ZM46.0171 43.7423C47.716 43.7423 49.0913 45.1469 49.0913 46.882C49.0913 48.5964 47.716 50.001 46.0171 50.001C44.3384 50.001 42.9632 48.5964 42.9632 46.882C42.9632 45.1469 44.3384 43.7423 46.0171 43.7423ZM23.2644 43.7423C24.9633 43.7423 26.3385 45.1469 26.3385 46.882C26.3385 48.5964 24.9633 50.001 23.2644 50.001C21.5857 50.001 20.2104 48.5964 20.2104 46.882C20.2104 45.1469 21.5857 43.7423 23.2644 43.7423Z",
    fill: "#96E188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3579 18.8529L18.1193 19.5012L18.1193 19.5012L17.3579 18.8529ZM16.5893 22.4036L17.5787 22.2581L17.5794 22.2633L16.5893 22.4036ZM18.5107 35.9538L19.5008 35.8134L19.5011 35.8153L18.5107 35.9538ZM50.8299 35.646L49.8332 35.5647L49.8333 35.5636L50.8299 35.646ZM52.6906 13.1292L51.694 13.0469C51.7314 12.5939 52.0697 12.2231 52.5174 12.1444L52.6906 13.1292ZM55.7446 12.5922L55.9205 13.5766L55.9178 13.5771L55.7446 12.5922ZM56.9783 10.8158L55.9926 10.9847L55.992 10.9811L56.9783 10.8158ZM55.2187 9.53722L55.0668 8.54883L55.0685 8.54857L55.2187 9.53722ZM50.3951 10.2788L50.2149 9.29513C50.2243 9.29341 50.2337 9.29182 50.2432 9.29037L50.3951 10.2788ZM49.1412 11.6833L48.1446 11.6006L48.1449 11.5973L49.1412 11.6833ZM48.7569 16.3102L49.7535 16.393L49.7527 16.4013L48.7569 16.3102ZM16.5965 18.2047C17.0581 17.6625 17.5648 17.2143 18.1797 16.909C18.8008 16.6006 19.4694 16.469 20.2096 16.469V18.469C19.716 18.469 19.3633 18.5543 19.0692 18.7003C18.7689 18.8494 18.4666 19.0932 18.1193 19.5012L16.5965 18.2047ZM15.6 22.5492C15.3987 21.1812 15.519 19.4702 16.5965 18.2047L18.1193 19.5012C17.5788 20.136 17.4159 21.1515 17.5787 22.2581L15.6 22.5492ZM17.5206 36.0942L15.5992 22.544L17.5794 22.2633L19.5008 35.8134L17.5206 36.0942ZM23.6276 41.4774C20.5478 41.4774 17.9517 39.1785 17.5203 36.0922L19.5011 35.8153C19.7978 37.9384 21.5702 39.4774 23.6276 39.4774V41.4774ZM45.6928 41.4774H23.6276V39.4774H45.6928V41.4774ZM51.8266 35.7273C51.5634 38.953 48.9232 41.4774 45.6928 41.4774V39.4774C47.8422 39.4774 49.6515 37.7921 49.8332 35.5647L51.8266 35.7273ZM53.6872 13.2116L51.8265 35.7284L49.8333 35.5636L51.694 13.0469L53.6872 13.2116ZM55.9178 13.5771L52.8638 14.1141L52.5174 12.1444L55.5714 11.6073L55.9178 13.5771ZM57.9639 10.6469C58.1972 12.0086 57.2765 13.3342 55.9205 13.5766L55.5686 11.6078C55.8306 11.561 56.0425 11.2755 55.9926 10.9847L57.9639 10.6469ZM55.0685 8.54857C56.4341 8.34107 57.732 9.26312 57.9645 10.6505L55.992 10.9811C55.9414 10.6789 55.6618 10.4814 55.3689 10.5259L55.0685 8.54857ZM50.2432 9.29037L55.0668 8.54883L55.3707 10.5256L50.547 11.2671L50.2432 9.29037ZM48.1449 11.5973C48.2426 10.4656 49.0651 9.50581 50.2149 9.29513L50.5753 11.2624C50.3498 11.3037 50.161 11.4965 50.1375 11.7694L48.1449 11.5973ZM47.7603 16.2274L48.1446 11.6006L50.1377 11.7661L49.7535 16.393L47.7603 16.2274ZM47.5232 16.469C47.5848 16.469 47.635 16.4473 47.675 16.4097C47.7158 16.3713 47.7528 16.3089 47.7611 16.2191L49.7527 16.4013C49.6474 17.5523 48.714 18.469 47.5232 18.469V16.469ZM20.2096 16.469H47.5232V18.469H20.2096V16.469ZM48.0913 46.882C48.0913 45.6792 47.1439 44.7423 46.0171 44.7423V42.7423C48.288 42.7423 50.0913 44.6146 50.0913 46.882H48.0913ZM46.0171 49.001C47.1482 49.001 48.0913 48.0597 48.0913 46.882H50.0913C50.0913 49.133 48.2838 51.001 46.0171 51.001V49.001ZM43.9632 46.882C43.9632 48.0641 44.9105 49.001 46.0171 49.001V51.001C43.7664 51.001 41.9632 49.1287 41.9632 46.882H43.9632ZM46.0171 44.7423C44.9147 44.7423 43.9632 45.6748 43.9632 46.882H41.9632C41.9632 44.6189 43.7621 42.7423 46.0171 42.7423V44.7423ZM25.3385 46.882C25.3385 45.6792 24.3912 44.7423 23.2644 44.7423V42.7423C25.5353 42.7423 27.3385 44.6146 27.3385 46.882H25.3385ZM23.2644 49.001C24.3955 49.001 25.3385 48.0597 25.3385 46.882H27.3385C27.3385 49.133 25.5311 51.001 23.2644 51.001V49.001ZM21.2104 46.882C21.2104 48.0641 22.1578 49.001 23.2644 49.001V51.001C21.0137 51.001 19.2104 49.1287 19.2104 46.882H21.2104ZM23.2644 44.7423C22.162 44.7423 21.2104 45.6748 21.2104 46.882H19.2104C19.2104 44.6189 21.0094 42.7423 23.2644 42.7423V44.7423Z",
    fill: "url(#paint1_linear_2927_19602)",
    mask: "url(#path-3-outside-1_2927_19602)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_2927_19602)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_2927_19602",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8633 28.2077H32.4656C33.315 28.2077 33.9824 27.5054 33.9824 26.6586C33.9824 25.791 33.315 25.1094 32.4656 25.1094H26.8633C26.0139 25.1094 25.3464 25.791 25.3464 26.6586C25.3464 27.5054 26.0139 28.2077 26.8633 28.2077"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8633 28.2077H32.4656C33.315 28.2077 33.9824 27.5054 33.9824 26.6586C33.9824 25.791 33.315 25.1094 32.4656 25.1094H26.8633C26.0139 25.1094 25.3464 25.791 25.3464 26.6586C25.3464 27.5054 26.0139 28.2077 26.8633 28.2077",
    fill: "url(#paint2_linear_2927_19602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8633 28.0077H32.4656V28.4077H26.8633V28.0077ZM32.4656 28.0077C33.1989 28.0077 33.7824 27.4007 33.7824 26.6586H34.1824C34.1824 27.6101 33.4311 28.4077 32.4656 28.4077V28.0077ZM33.7824 26.6586C33.7824 25.8975 33.2006 25.3094 32.4656 25.3094V24.9094C33.4294 24.9094 34.1824 25.6846 34.1824 26.6586H33.7824ZM32.4656 25.3094H26.8633V24.9094H32.4656V25.3094ZM26.8633 25.3094C26.1283 25.3094 25.5464 25.8975 25.5464 26.6586H25.1464C25.1464 25.6846 25.8994 24.9094 26.8633 24.9094V25.3094ZM25.5464 26.6586C25.5464 27.4007 26.13 28.0077 26.8633 28.0077V28.4077C25.8977 28.4077 25.1464 27.6101 25.1464 26.6586H25.5464Z",
    fill: "url(#paint3_linear_2927_19602)",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-2_2927_19602)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2927_19602",
    x: 0.0449219,
    y: 0.392578,
    width: 50.3066,
    height: 41.3828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_2927_19602"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2927_19602",
    x: -8.48047,
    y: -15.4805,
    width: 90.4805,
    height: 90.4805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2927_19602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2927_19602",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_2927_19602",
    x: 10.3457,
    y: 10.1094,
    width: 38.6367,
    height: 33.0977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2927_19602"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2927_19602",
    result: "effect2_dropShadow_2927_19602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2927_19602",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2927_19602",
    x1: 42.4287,
    y1: 2,
    x2: 23.8135,
    y2: 30.4687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BF763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2927_19602",
    x1: 50.5561,
    y1: 14.2357,
    x2: 24.7332,
    y2: 46.2177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2927_19602",
    x1: 25.9587,
    y1: 25.6689,
    x2: 35.5097,
    y2: 26.5369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2927_19602",
    x1: 33.0521,
    y1: 26.1487,
    x2: 25.7205,
    y2: 26.2615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/OrderIcon.8388c39e534f795c76caa51dbc0413de.svg";
export { ForwardRef as ReactComponent };